<template>
  <settings-page-layout
      :is-loading="isLoading"
      toolbar-title="pages.mods.branches.title"
      :progress-bar-loading="isLoading === 'branches'"
      :toolbar-buttons="toolbarButtons">
    <v-card
        elevation="2"
    >
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left" style="width:50%">
              {{ $t('pages.mods.branches.headers.name') }}
            </th>
            <th class="text-left">
              {{ $t('pages.mods.branches.headers.isPublic') }}
            </th>
            <th class="text-right">
              {{ $t('pages.mods.branches.headers.actions') }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-ripple
              v-for="(item, index) in branches"
              :key="index"
              @click.prevent="editBranch(item.id)"
              style="cursor: pointer;user-select: none"
          >
            <td>{{ item.name }}</td>
            <td>
              <v-icon :color="item.isPublic === true ? 'teal' : 'error'">{{item.isPublic === true ? 'mdi-earth' : 'mdi-earth-off'}}</v-icon>
            </td>
            <td class="align-end">
              <v-row align="end">
                <v-col class="text-right">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          @click.stop="editBranch(item.id)"
                          :disabled="isLoading != null"
                          v-on="on"
                          v-bind="attrs">
                        <v-icon
                            small>
                          mdi-cog
                        </v-icon>
                      </v-btn>
                    </template>

                    <span>{{ $t('pages.mods.branches.buttons.edit') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          @click.stop="deleteBranch(item.id)"
                          :disabled="isLoading != null  || branches.length === 1"
                          :loading="isLoading === 'delete' && selected === item.id"
                          v-on="on"
                          v-bind="attrs">
                        <v-icon
                            small>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>

                    <span>{{ $t('pages.mods.branches.buttons.delete') }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </settings-page-layout>
</template>

<script>
import SettingsPageLayout from "@/components/SettingsPageLayout";
import {AlertService} from "@/services/AlertService";
import {DialogService} from "@/services/DialogService";
import {ModsService} from "@/services/ModsService";

export default {
  name: "ModBranchesView",
  components: {SettingsPageLayout},
  data() {
    return {
      isLoading: null,
      selected: null,

      toolbarButtons: [
        {
          isDisabled: l => l != null,
          isLoading: () => false,
          onClick: this.createBranch,
          icon: 'mdi-source-branch-plus',
          text: 'pages.mods.branches.toolbar.createBranch'
        },
        {
          isDisabled: l => l != null,
          isLoading: l => l === 'branches',
          onClick: this.loadBranches,
          icon: 'mdi-refresh',
          text: 'pages.mods.branches.toolbar.refresh'
        }
      ],

      branches: []
    }
  },

  watch: {
    '$route.params': {
      handler() {
        this.loadBranches();
      }
    }
  },

  methods: {
    loadBranches(){
      this.isLoading = 'branches'
      AlertService.clearAlert();
      ModsService.getBranches(this.$route.params.modId).then(branches => {
        this.$log.info('Loaded branches:',branches)
        this.branches = branches
      }).catch(() => {
        AlertService.displayAlert('error', 'pages.mods.branches.messages.failedToLoad', 0)
      }).finally(() => {
        this.isLoading = null;
      })
    },
    createBranch(){
      this.$router.push(`/mods/${this.$route.params.modId}/branches/create`);
    },
    editBranch(branchId){
      if(this.isLoading != null) return;

      this.$log.debug('Edit branch:',branchId)

      this.$router.push(`/mods/${this.$route.params.modId}/branches/edit/${branchId}`)
    },
    deleteBranch(branchId){
      if(this.branches.length === 1) return;

      this.$log.debug('Delete branch:',branchId)
      DialogService.addDialog({
        title: 'pages.mods.branches.deleteDialog.title',
        text: 'pages.mods.branches.deleteDialog.text',
        width: 400,
        buttons: [
          {
            text: 'pages.mods.branches.deleteDialog.buttons.cancel',
            color: 'secondary'
          },
          {
            text: 'pages.mods.branches.deleteDialog.buttons.delete',
            color: 'primary'
          }
        ]
      }).then(res => {
        if(res !== 1) return;

        this.selected = branchId;
        this.isLoading = 'delete';
        AlertService.clearAlert();
        ModsService.deleteBranch(this.$route.params.modId, branchId).then(() => {
          this.loadBranches()
        }).catch(() => {
          AlertService.displayAlert('error', 'pages.mods.branches.messages.failedToDelete', 2000)
          this.isLoading = null
        })
      })
    }
  },

  mounted() {
    this.loadBranches();
  }
}
</script>

<style scoped>

</style>
